module.exports = __webpack_public_path__ + "img/ES-M-18.2ac0a076.svg";